import { EMPTY_LIST } from '../../constants/common'

import {
  WYSIWYG_EDITOR_CARET_HIT_TEST_INSET,
  WYSIWYG_EDITOR_INSET_AUTO,
  WYSIWYG_EDITOR_POSITION_STICKY,
} from './WysiwygEditor.constants'

function isStickyElement(element) {
  return getComputedStyle(element).position === WYSIWYG_EDITOR_POSITION_STICKY
}

function isStickyElementPinnedToTop(element) {
  return getComputedStyle(element).top !== WYSIWYG_EDITOR_INSET_AUTO
}

function isStickyElementPinnedToBottom(element) {
  return getComputedStyle(element).bottom !== WYSIWYG_EDITOR_INSET_AUTO
}

function getEditorPointStickyElements({ editor, x, y }) {
  const elements = document.elementsFromPoint(x, y)

  return elements.includes(editor.iframeElement)
    ? elements
        .slice(0, elements.indexOf(editor.iframeElement))
        .filter(isStickyElement)
    : EMPTY_LIST
}

function getEditorTopStickyEdge({ editor, x, y }) {
  const [stickyElement] = getEditorPointStickyElements({ editor, x, y }).filter(
    isStickyElementPinnedToTop
  )

  return stickyElement
    ? getEditorTopStickyEdge({
        editor,
        x,
        y:
          stickyElement.getBoundingClientRect().bottom +
          WYSIWYG_EDITOR_CARET_HIT_TEST_INSET,
      })
    : y
}

function getEditorBottomStickyEdge({ editor, x, y }) {
  const [stickyElement] = getEditorPointStickyElements({ editor, x, y }).filter(
    isStickyElementPinnedToBottom
  )

  return stickyElement
    ? getEditorBottomStickyEdge({
        editor,
        x,
        y:
          stickyElement.getBoundingClientRect().top -
          WYSIWYG_EDITOR_CARET_HIT_TEST_INSET,
      })
    : y
}

function getEditorRectTopStickyOverlap({ editor, rect }) {
  const y = rect.top + WYSIWYG_EDITOR_CARET_HIT_TEST_INSET

  return (
    getEditorTopStickyEdge({
      editor,
      x: rect.left + WYSIWYG_EDITOR_CARET_HIT_TEST_INSET,
      y,
    }) - y
  )
}

function getEditorRectBottomStickyOverlap({ editor, rect }) {
  const y = rect.bottom - WYSIWYG_EDITOR_CARET_HIT_TEST_INSET

  return (
    y -
    getEditorBottomStickyEdge({
      editor,
      x: rect.left + WYSIWYG_EDITOR_CARET_HIT_TEST_INSET,
      y,
    })
  )
}

export function getWysiwygEditorStickyScrollDelta({ editor, rect }) {
  return (
    getEditorRectBottomStickyOverlap({ editor, rect }) -
    getEditorRectTopStickyOverlap({ editor, rect })
  )
}
